import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Search, X } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

const SearchBar = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')
  const [isExpanded, setIsExpanded] = useState(false)

  const handleSearch = (e) => {
    e.preventDefault()
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}&mode=keyword`)
      setSearchTerm('')
      setIsExpanded(false)
    }
  }

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
    if (isExpanded) {
      setSearchTerm('')
    }
  }

  // 根据语言调整占位符
  const isEnglish = i18n.language === 'en-US'
  const placeholder = isEnglish ? 'Search...' : t('common.search')

  return (
    <div className="relative">
      {!isExpanded ? (
        // 折叠状态：只显示搜索图标
        <button
          onClick={handleToggle}
          className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          title={t('common.search')}
        >
          <Search size={18} />
        </button>
      ) : (
        // 展开状态：显示完整搜索框
        <form onSubmit={handleSearch} className="relative">
          <div className="relative">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={placeholder}
              autoFocus
              className="pl-10 pr-10 py-2 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors w-48 md:w-56 ring-1 ring-inset ring-gray-300"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search size={16} className="text-gray-400" />
            </div>
            <button
              type="button"
              onClick={handleToggle}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
            >
              <X size={16} />
            </button>
          </div>
          <button type="submit" className="sr-only">
            {t('common.search')}
          </button>
        </form>
      )}
      
      {/* 展开状态的背景遮罩 */}
      {isExpanded && (
        <div 
          className="fixed inset-0 z-10" 
          onClick={handleToggle}
        />
      )}
    </div>
  )
}

export default SearchBar 